import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { LoadingIndicator } from "../Base/LoadingIndicator/LoadingIndicator";
import { LoadingOverlay } from "../Base/LoadingOverlay/LoadingOverlay";
import {
  EVENT,
  getAppInsightsCookies,
  TRACK_METHOD,
  trackAppInsightsTelemetry,
} from "~/logging/applicationInsightsService";
import "./RedirectPage.css";

export const additionalInfoDelay = 5000;

export function RedirectPage() {
  // Get Application Insights cookies for debugging in case of errors
  const { sessionId: aiSessionId, userId: aiUserId } = getAppInsightsCookies();

  const { t } = useTranslation();

  const currentDateTime = new Date().toISOString();
  const [showRedirectingInfo, setShowRedirectingInfo] = React.useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      trackAppInsightsTelemetry(
        { name: EVENT.SHOW_REDIRECTING_INFO },
        TRACK_METHOD.EVENT
      );

      setShowRedirectingInfo(true);
    }, additionalInfoDelay);

    return () => clearTimeout(timeout);
  }, []);

  if (!showRedirectingInfo) {
    return (
      <LoadingOverlay>
        <LoadingIndicator />
      </LoadingOverlay>
    );
  }

  return (
    <div className="redirect-page">
      <h1 className="redirect-page__header-title">
        {t("redirect_page.title")}
      </h1>
      <p>{t("redirect_page.delay_message")}</p>
      <div className="redirect-page__debug-info">
        {currentDateTime}:{aiSessionId && aiSessionId}|{aiUserId && aiUserId}
      </div>
    </div>
  );
}
